/* 
custom.js
Version: v1.2
Date: 2026-01-06

CHANGELOG
v1.2
- Fix: Serialize customer fields as null (not undefined) in checkout context attributes to avoid downstream "missing customerId" errors.

v1.1
- Refactor: Replace jQuery usage with vanilla JavaScript while preserving existing behavior.
- Reliability: Keep checkout click handler attached even if the cart drawer DOM re-renders (MutationObserver rebind).
- Safety: Guard optional dependencies (for example window.backend) to avoid hard crashes when unavailable.

Notes
- This file preserves the original behavior of injecting checkout attributes and redirecting to /checkout.
- This file preserves the original party URL parsing, external party fetch, localStorage keys, and banner updates.
*/

(function () {
  // --- Banner updates ---
  function updateShoppingBarBanner() {
    const partyName = localStorage.getItem("CURRENT_PARTY_NAME");
    const partnerName = document.querySelector("[data-partner-name]")?.textContent;

    console.log("partyName", partyName);
    console.log("partnerName", partnerName);

    const shoppingBarText = document.querySelector(".shopping-with-bar__text");
    if (!shoppingBarText) return;

    if (partyName && partyName !== "undefined") {
      shoppingBarText.innerHTML =
        'You are shopping with <span class="shopping-with-bar__partner_name" data-partner-name>' +
        partyName +
        "</span>";
    } else if (partnerName && partnerName !== "undefined") {
      shoppingBarText.innerHTML =
        'You are shopping with <span class="shopping-with-bar__partner_name" data-partner-name>' +
        partnerName +
        "</span>";
    }
  }

  // Add storage event listener (same behavior)
  window.addEventListener("storage", (e) => {
    if (e.key === "CURRENT_PARTY_NAME") {
      updateShoppingBarBanner();
    }
  });

  // Party API fetch (same endpoint and basic behavior)
  async function getPartyWebAlias(partyId) {
    try {
      const response = await fetch(
        "https://ff-prd.api.sultans.co/dashboard/parties/" +
          encodeURIComponent(partyId),
        {
          method: "GET",
          // Preserve original behavior: uses `this.headers` (often window.headers if present)
          headers: this && this.headers,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch party info");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching party webAlias:", error);
      return null;
    }
  }

  // --- Checkout interception ---
  // Keep a reference so we can remove and re-add the same handler (unbind/bind equivalent)
  const checkoutClickHandlerByEl = new WeakMap();

  async function configureCustomCheckout(cart) {
    console.log("configureCustomCheckout", cart);

    // id = CartDrawer-Checkout
    const customCheckout = document.querySelector(
      'button[id="CartDrawer-Checkout"]'
    );
    console.log("customCheckout", customCheckout);

    if (!customCheckout) return;

    // Remove prior handler (jQuery unbind equivalent)
    const existing = checkoutClickHandlerByEl.get(customCheckout);
    if (existing) {
      customCheckout.removeEventListener("click", existing, false);
    }

    const handler = async (e) => {
      e.stopPropagation();
      e.preventDefault();

      const params = new URLSearchParams();

      const currentSite = localStorage.getItem("CURRENT_SITE");
      if (currentSite) {
        console.log("currentSit added: ", currentSite);
        params.append("attributes[sponsorWebAlias]", currentSite);
      }

      let sessionId = sessionStorage.getItem("CHECKOUT_CUSTOM_SESSION_ID");
      if (!sessionId) {
        sessionId = String(Date.now());
        sessionStorage.setItem("CHECKOUT_CUSTOM_SESSION_ID", sessionId);
      }

      const context = {
        curSite: localStorage.getItem("CURRENT_SITE") ?? null,
        customerId: window?.customer?.id ?? null,
        customerEmail: window?.customer?.email ?? null,
        isPartner: window?.customer?.isPartner ?? null,
      };

      console.log("customCheckout clicked", context);

      params.append("attributes[sessionID]", sessionId);
      params.append("attributes[context]", btoa(JSON.stringify(context)));
      params.append(
        "attributes[partyID]",
        localStorage.getItem("CURRENT_PARTY_ID")
      );

      const checkoutURL = "/checkout?" + params.toString();
      console.log("Redirecting to checkout:", checkoutURL);

      setTimeout(() => {
        window.location.href = checkoutURL;
      }, 500);
    };

    checkoutClickHandlerByEl.set(customCheckout, handler);
    customCheckout.addEventListener("click", handler, false);
  }

  async function initConfigureCustomCheckout() {
    const cart = await fetch("/cart.js")
      .then((res) => res.json())
      .catch((e) => console.log(e));

    configureCustomCheckout(cart);
  }

  // Make function globally accessible (same as original)
  window.initConfigureCustomCheckout = initConfigureCustomCheckout;

  document.addEventListener("DOMContentLoaded", initConfigureCustomCheckout);

  // Keep handler attached if CartDrawer re-renders (common in cart drawers)
  const observer = new MutationObserver(() => {
    // Avoid extra network calls: cart is not used by configureCustomCheckout in current logic.
    configureCustomCheckout(undefined);
  });

  document.addEventListener("DOMContentLoaded", () => {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });

  // Consolidated DOMContentLoaded logic for banner + party handling
  document.addEventListener("DOMContentLoaded", async () => {
    if (localStorage.getItem("CURRENT_PARTY_NAME")) {
      console.log(
        "CURRENT_PARTY_NAME",
        localStorage.getItem("CURRENT_PARTY_NAME")
      );
      updateShoppingBarBanner();
    }

    console.log("DOMContentLoaded party");
    const urlParams = new URLSearchParams(window.location.search);
    const partyId = urlParams.get("party");

    if (!partyId) return;

    const response = await getPartyWebAlias(partyId);

    if (response && response.site && response.closed === false) {
      localStorage.setItem("CURRENT_PARTY_ID", partyId);

      if (response.partyName) {
        localStorage.setItem("CURRENT_PARTY_NAME", response.partyName);
      }

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("pws", response.site);
      localStorage.setItem("CURRENT_SITE", response.site);

      // Preserve original dependency on window.backend, but avoid hard crashes if missing.
      const partner =
        window.backend && typeof window.backend.getPartnerBySite === "function"
          ? await window.backend.getPartnerBySite(response.site, false)
          : null;

      document.dispatchEvent(
        new CustomEvent("theme:partner:update", { detail: { partner } })
      );

      // Update the banner after partner info is set
      setTimeout(updateShoppingBarBanner, 100);

      window.history.replaceState({}, "", newUrl);
    } else {
      localStorage.removeItem("CURRENT_PARTY_ID");
      localStorage.removeItem("CURRENT_PARTY_NAME");
      updateShoppingBarBanner();
    }
  });
})();
